import { computed, inject, Injectable } from '@angular/core';
import { RemoteConfigService } from './remote-config.service';

@Injectable({
  providedIn: 'root',
})
export class FloorPlansFeatureService {
  private remoteConfigService = inject(RemoteConfigService);

  public state = computed(() => this.remoteConfigService.floorPlansWebState());
  public isVisible = computed(() => this.remoteConfigService.floorPlansWebVisible());
  public showResearchPreviewBadge = computed(() => this.remoteConfigService.floorPlansWebShowResearchPreviewBadge());
  public isFullyEnabled = computed(() => this.state() === 'on');
}
